import { render, staticRenderFns } from "./UpdateMobile.vue?vue&type=template&id=5b3618aa&scoped=true"
import script from "./UpdateMobile.vue?vue&type=script&lang=js"
export * from "./UpdateMobile.vue?vue&type=script&lang=js"
import style0 from "./UpdateMobile.vue?vue&type=style&index=0&id=5b3618aa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3618aa",
  null
  
)

export default component.exports